import React from 'react';
export const TruthSection = () => {
  return <section className="py-16 px-6 md:px-10 bg-navy text-cream" data-id="element-302">
      <div className="max-w-4xl mx-auto" data-id="element-303">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-304">
          La verdad que nadie te dijo
        </h2>
        <div className="space-y-8 serif-text text-lg" data-id="element-305">
          <p data-id="element-306">
            Tu problema nunca fue falta de disciplina. Ni falta de esfuerzo. Ni
            irresponsabilidad.
          </p>
          <p className="text-xl md:text-2xl font-semibold" data-id="element-307">
            Tu problema es que jamás te dieron un sistema.
          </p>
          <p data-id="element-308">
            Sin un método claro, hasta la mujer más fuerte del mundo termina
            cansada, confundida y creyendo que está fallando… cuando en realidad
            está haciendo milagros todos los días.
          </p>
          <div className="bg-navy/30 p-6 rounded-lg border-l-4 border-gold" data-id="element-309">
            <p className="text-xl font-semibold mb-4" data-id="element-310">La verdad es simple:</p>
            <p className="text-2xl font-bold text-gold" data-id="element-311">
              Tu dinero no se va. Tu dinero se evapora.
            </p>
          </div>
          <p data-id="element-312">
            No desaparece por un gasto grande. Sino por pequeñas cosas que
            —sumadas— se comen tu quincena:
          </p>
          <p data-id="element-313">
            Snacks del trabajo. Uber porque estabas cansada. Una compra rápida.
            Una salida pequeña. Un envío para un familiar. El famoso "solo un
            poquito".
          </p>
          <p data-id="element-314">
            No son lujos. No son excesos. Son cosas normales que juntas se
            vuelven un agujero invisible.
          </p>
          <p className="text-xl font-semibold" data-id="element-315">
            No estás fallando. Solo te falta organización real.
          </p>
        </div>
      </div>
    </section>;
};